import React, { type FC } from 'react';
import RegisterLayout from '@/registration/component/Register/Layout';
import BaseTransitionSlideLeft from '@/base/Transition/SlideLeft';
import LayoutFooter from '@/registration/component/Register/Layout/Footer';
import { UiButton, UiHStack, UiIconCaretLeft, UiIconCaretRight, UiStack } from '@/lib/ui';
import TicketList from '../MainTickets/TicketList';
import { TicketType } from '@/api/constant';
import { useRegisterSteps } from '@/registration/hook/useRegisterSteps';
import { useRegistrationQuery } from '@/registration/hook/useRegistrationQuery';
import QueryContainer, { StandardSpinner } from '@/base/QueryContainer/QueryContainer';
import { useRegisterRoute } from '@/registration/hook/useRegisterRoute';
import { useEventSettingsQuery } from '@/registration/hook/useEventSettingsQuery';
import InfoBox from '@/registration/component/InfoBox';
import { useRegisterUpsellSteps } from '@/registration/hook/useRegisterUpsellSteps';
import BaseThemeButton from '@/base/ThemeButton';
import BrandFooter from '@/registration/component/Register/Layout/BrandFooter';

interface WorkshopTicketsProps {
  isUpsell?: boolean
}

const WorkshopTickets: FC<WorkshopTicketsProps> = ({ isUpsell }) => {
  const { eventId } = useRegisterRoute();
  const registrationQuery = useRegistrationQuery(eventId);
  const { data: eventSetting } = useEventSettingsQuery(eventId);
  const { toNextStep: defaultToNextStep, toPreviousStep: defaultToPreviousStep } = useRegisterSteps();
  const { toNextStep: upsellToNextStep, toPreviousStep: upsellToPreviousStep } = useRegisterUpsellSteps();

  const toNextStep = isUpsell ? upsellToNextStep : defaultToNextStep;
  const toPreviousStep = isUpsell ? upsellToPreviousStep : defaultToPreviousStep;

  return (
    <RegisterLayout>
      <QueryContainer query={registrationQuery} loadingComponent={<StandardSpinner />}>
        {(registration) => {
          return (
            <>
              <BaseTransitionSlideLeft>
                <UiStack flexGrow={1} spacing={8}>
                  <InfoBox
                    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
                    title={eventSetting?.pageMetadata?.workshopTicket?.title || 'Workshop tickets'}
                    description={eventSetting?.pageMetadata?.workshopTicket?.description}
                  />
                  <TicketList ticketType={TicketType.Workshop} onEmpty={toNextStep} registration={registration} isUpsell={isUpsell} />
                </UiStack>
              </BaseTransitionSlideLeft>
              <UiStack height={96} />
              <LayoutFooter>
                <UiHStack justifyContent={'space-between'} flexGrow={1}>
                  {/*<UiButton*/}
                  {/*  size={'lg'}*/}
                  {/*  colorScheme={'primary'}*/}
                  {/*  onClick={toPreviousStep}*/}
                  {/*  variant={'ghost'}*/}
                  {/*  fontSize={'lg'}*/}
                  {/*  leftIcon={(*/}
                  {/*    <UiIconCaretLeft color={'primary.800'} size={'xl'} weight={'bold'}/>*/}
                  {/*  )}*/}
                  {/*>*/}
                  {/*  Previous*/}
                  {/*</UiButton>*/}
                  {/*<UiButton*/}
                  {/*  size={'lg'}*/}
                  {/*  colorScheme={'primary'}*/}
                  {/*  onClick={toNextStep}*/}
                  {/*  variant={'ghost'}*/}
                  {/*  fontSize={'lg'}*/}
                  {/*  rightIcon={(*/}
                  {/*    <UiIconCaretRight color={'primary.800'} size={'xl'} weight={'bold'}/>*/}
                  {/*  )}*/}
                  {/*>*/}
                  {/*  Next*/}
                  {/*</UiButton>*/}

                  <BaseThemeButton
                    theme={'gray'}
                    onClick={toPreviousStep}
                    leftIcon={(
                      <UiIconCaretLeft color={'primary.800'} size={'lg'} weight={'bold'}/>
                    )}
                  >
                    Prev
                  </BaseThemeButton>
                  <BrandFooter/>
                  <BaseThemeButton
                    theme={'primary'}
                    onClick={toNextStep}
                    type={'submit'}
                    rightIcon={(
                      <UiIconCaretRight color={'primary.800'} size={'lg'} weight={'bold'}/>
                    )}
                  >
                    Next
                  </BaseThemeButton>
                </UiHStack>
              </LayoutFooter>
            </>
          );
        }}
      </QueryContainer>
    </RegisterLayout>
  );
};

export default WorkshopTickets;
